import axios from '@fs/zion-axios'
import { getSession } from '@fs/zion-session'

export async function getRoles() {
  const url = `/service/cmn/assignments/assignments`
  const { data } = await axios.get(url)
  return data.assignmentList
}

export async function getActiveRole(ignoreCache) {
  const { session } = await getSession(ignoreCache)
  if (session) {
    const val = session.values && session.values.find((v) => v.name === 'AssignmentServiceAssignment')
    return val ? val.value : ''
  }
  return undefined
}

export function reloadIfOK(status) {
  status === 200 && window.location.reload()
}

export async function enterRole(role) {
  await deleteTFCache()
  const url = `/service/cmn/assignments/assignments/${role}/new-access-token`
  const result = await axios.put(url)
  const cookieValue = `fssessionid=${result.data}; path=/;`
  if (window.location.hostname.endsWith('familysearch.org')) {
    document.cookie = `${cookieValue} domain=familysearch.org`
  } else {
    document.cookie = cookieValue
  }
  reloadIfOK(result.status)
}

export async function exitRole() {
  const { status } = await getSession(true)
  reloadIfOK(status)
}

export async function deleteTFCache() {
  const url = `/service/tree/tf/cache/session`
  await axios.delete(url)
}
